/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Assign_DriverInputs */

const vi_order_action_assign_driver = /** @type {(inputs: Order_Action_Assign_DriverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhận đơn giao`)
};

/**

* @param {Order_Action_Assign_DriverInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_assign_driver = /** @type {((inputs?: Order_Action_Assign_DriverInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Assign_DriverInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_assign_driver(inputs)
});